import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { hideModal } from "../../../../../../../store/slices/modal";
import { generateUuId } from "../../../../../../../utils/helperFunc";
import useHttp from "../../../../../../../hooks/useHttp";
import { VALIDATE_LOADS_URL } from "../../../../../../../utils/api-ends";
import LoaderImg from "../../../../../../../assets/media/loader.gif";

const PalletLoadManageModal = ({ modalData }) => {
  const [name, setName] = useState("");
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [width, setWidth] = useState("");
  const [length, setLength] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [weightErr, setWeightErr] = useState("");
  const [heightErr, setHeightErr] = useState("");
  const [widthErr, setWidthErr] = useState("");
  const [lengthErr, setLengthErr] = useState("");

  const dispatch = useDispatch();
  const { isForUpdate, item, loadPostContextDispatch } = modalData;
  const { isLoading, error, sendRequests } = useHttp();

  const onChangeName = (e) => setName(e.target.value);
  const onChangeWeight = (e) => setWeight(e.target.value);
  const onChangeHeight = (e) => setHeight(e.target.value);
  const onChangeWidth = (e) => setWidth(e.target.value);
  const onChangeLength = (e) => setLength(e.target.value);

  useEffect(() => {
    if (isForUpdate === true) {
      setName(item.name);
      setWeight(item.weight);
    }
  }, [isForUpdate, item]);

  // Show or hide error messages on mouse enter or leave
  const showErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "true");
  const hideErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "false");

  const closeModal = () => dispatch(hideModal());

  const handleSaveData = () => {
    // Clear error messages
    setNameErr("");
    setWeightErr("");
    setHeightErr("");
    setWidthErr("");
    setLengthErr("");

    // Validate data
    if (name === "") setNameErr("Name is required");
    if (weight === "") setWeightErr("Weight is required");
    if (height === "") setHeightErr("Height is required");
    if (width === "") setWidthErr("Width is required");
    if (length === "") setLengthErr("Length is required");
    if (
      name === "" ||
      weight === "" ||
      height === "" ||
      width === "" ||
      length === ""
    )
      return;

    // Validate data from backend
    const response = (data) => {
      // Append or update data to pallet list
      if (isForUpdate === false) {
        // Save data
        loadPostContextDispatch({
          type: "ADD_PALLET_LOADER_TO_LIST",
          payload: {
            id: generateUuId(8),
            name,
            weight,
            height,
            width,
            length,
            isExpand: true,
          },
        });
      } else {
        // Update data
        loadPostContextDispatch({
          type: "UPDATE_PALLET_LOADER_TO_LIST",
          payload: {
            id: item.id,
            name,
            weight,
            height,
            width,
            length,
            isExpand: true,
          },
        });
      }

      closeModal();
    };

    sendRequests(
      {
        url: VALIDATE_LOADS_URL,
        method: "POST",
        data: {
          load_type: "pallet",
          load_data: {
            name,
            weight,
            height,
            width,
            length,
          },
        },
      },
      response
    );
  };

  // Append error messages
  useEffect(() => {
    if (error?.errors) {
      if (error.errors?.name) setNameErr(error.errors.name);
      if (error.errors?.weight) setWeightErr(error.errors.weight);
      if (error.errors?.height) setHeightErr(error.errors.height);
      if (error.errors?.width) setWidthErr(error.errors.width);
      if (error.errors?.length) setLengthErr(error.errors.length);
    }
  }, [error]);

  return (
    <div className="col-xl-7 col-lg-8 col-md-10">
      <div className="load-add-edit-modal">
        <div className="row">
          {error?.message && <p className="auth-error">{error.message}</p>}
          <div className="col-md-6">
            <div className="information-field border-0">
              <div className="input-box-area" single-labe="true">
                <label> Material Content </label>
                <input
                  type="text"
                  placeholder="Material Content"
                  value={name}
                  onChange={onChangeName}
                />
                {nameErr?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    <p>{nameErr}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="information-field border-0">
              <div className="input-box-area" single-labe="true">
                <label>
                  Pallet Weight <span className="opacity-50">(kg)</span>
                </label>
                <input
                  type="number"
                  placeholder="Pallet Weight"
                  value={weight}
                  onChange={onChangeWeight}
                  min="0"
                />
                {weightErr?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    <p>{weightErr}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="information-field border-0">
              <div className="input-box-area" single-labe="true">
                <label>
                  Pallet Height <span className="opacity-50">(inches)</span>
                </label>
                <input
                  type="number"
                  placeholder="Pallet Height"
                  value={height}
                  onChange={onChangeHeight}
                  min="0"
                />
                {heightErr?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    <p>{heightErr}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="information-field border-0">
              <div className="input-box-area" single-labe="true">
                <label>
                  Pallet Width <span className="opacity-50">(inches)</span>
                </label>
                <input
                  type="number"
                  placeholder="Pallet Width"
                  value={width}
                  onChange={onChangeWidth}
                  min="0"
                />
                {widthErr?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    <p>{widthErr}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="information-field border-0">
              <div className="input-box-area" single-labe="true">
                <label>
                  Pallet Length <span className="opacity-50">(inches)</span>
                </label>
                <input
                  type="number"
                  placeholder="Pallet Length"
                  value={length}
                  onChange={onChangeLength}
                  min="0"
                />
                {lengthErr?.length > 0 && (
                  <div
                    className="error"
                    show-tittle="false"
                    onMouseEnter={showErrorMessage}
                    onMouseLeave={hideErrorMessage}
                  >
                    <i className="fa-solid fa-circle-exclamation"></i>
                    <p>{lengthErr}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="multiple-btn modal-button">
          <button onClick={handleSaveData}>
            Save
            {isLoading && (
              <img src={LoaderImg} alt="" style={{ width: "20px" }} />
            )}
          </button>
          <button onClick={closeModal}> Cancel </button>
        </div>
      </div>
    </div>
  );
};

export default PalletLoadManageModal;
